module.exports = __webpack_public_path__ + "static/media/shuttle.b63aa717.png";